import { EmptyValue } from "@/molecules/ChipsCell"

import styles from "./McpServerCells.module.scss"

export const EndpointCell = (endpoint: string) =>
  endpoint ? (
    <span className={styles.endpoint}>{endpoint}</span>
  ) : (
    <EmptyValue />
  )
